import { Heading, Modal, theme, Warning } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Radio } from 'antd'
import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { ActionModalProps } from './TaskModals'

const TeamModal = ({ isModalVisible, setIsModalVisible }: ActionModalProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)
  const [radioValue, setRadioValue] = useState<'all' | 'specific'>('all')

  const onChange = (e: any) => {
    setRadioValue(e.target.value)
  }

  return (
    <Modal
      closeButton
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      classicPadding
      closeOnConfirm
      onConfirm={() => ''}
      onCancel={() => ''}
      localisation={{
        confirmText: t('general.buttons.save', {
          ns: NAMESPACE.RESOURCES
        }),
        cancelText: t('general.buttons.cancel', {
          ns: NAMESPACE.RESOURCES
        })
      }}
    >
      <TitleContainer>
        <Warning size={24} color={theme.color.status.warning} />
        <Title level={3}>{t(toDosConstants.CHANGE_TEAM_MEMBERS)}</Title>
      </TitleContainer>
      <Divider />
      <TeamModalText weight="bold">
        {t(toDosConstants.CHANGE_TEAM_MEMBERS_DESCRIPTION)}
      </TeamModalText>
      <TeamModalContent>
        <Radio.Group onChange={onChange} value={radioValue}>
          <StyledRadio value="all">All Service Users</StyledRadio>
          <StyledRadio value="specific">Specific Service Users</StyledRadio>
        </Radio.Group>
        {/* <Select options></Select> */}
      </TeamModalContent>
      <Divider />
    </Modal>
  )
}
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`
const Title = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const TeamModalText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
`
const TeamModalContent = styled.div`
  margin: 8px 0 24px;
`

const StyledRadio = styled(Radio)`
  padding: 8px 0 0;
  margin: 0;
`

export default TeamModal
